export default "__VITE_ASSET__DweS34Sr__"